// import React from "react";
// import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

// const FloatingLabelInputField = ({
//     errors,
//     label,
//     type,
//     placeholder,
//     field,
//     register = () => {},
//     handleBlur = () => {},
//     height = "",
//     style = "",
//     disabled,
//     defaultValue,
// }) => {
//     return (
//         <div className="flex-1">
//             <div className={`relative`}>
//                 <input
//                     type={type}
//                     id={field}
//                     name={field}
//                     {...register(field, {
//                         onBlur: handleBlur,
//                     })}
//                     className="block px-2.5 pb-2.5 pt-2 w-full text-base text-gray-900 bg-transparent rounded border border-gray-300 appearance-none dark:border-gray-600 dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-600 peer"
//                     placeholder=" "
//                     defaultValue={defaultValue}
//                     disabled={disabled}
//                 />
//                 <label
//                     htmlFor={field}
//                     className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
//                 >
//                     {label}
//                 </label>
//             </div>
//             <ErrorTextWithIcon text={errors?.[field]?.message} />
//         </div>
//     );
// };

// export default FloatingLabelInputField;

import React, { useEffect, useState } from "react";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

const FloatingLabelInputField = ({
    errors,
    label,
    type,
    placeholder,
    field,
    register = () => {},
    handleBlur = () => {},
    height = "",
    style = "",
    disabled,
    defaultValue,
    enableTranslation = false,
    translatedValue = "",
    getEnglishTranslation = async () => "",
}) => {
    const [translation, setTranslation] = useState();
    const [isTranslating, setIsTranslating] = useState(false);

    const handleInputBlur = async (e) => {
        // Call the original handleBlur function first

        // If translation is enabled and there is a value, translate it
        if (enableTranslation && e.target.value) {
            setIsTranslating(true);
            try {
                const translated = await getEnglishTranslation(e.target.value);
                setTranslation(translated?.data);
            } catch (error) {
                console.error("Translation error:", error);
                setTranslation("Translation failed");
            } finally {
                setIsTranslating(false);
            }
        } else {
            setTranslation("");
        }
        handleBlur(e);
    };

    useEffect(() => {
        if (translatedValue) setTranslation(translatedValue);
    }, [translatedValue]);

    return (
        <div className="flex-1">
            <div className={`relative`}>
                <div className="block px-2.5 pb-2.5 pt-2 w-full text-base text-gray-900 bg-transparent rounded border border-gray-300 appearance-none dark:border-gray-600 dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-600 peer">
                    <input
                        type={type}
                        id={field}
                        name={field}
                        {...register(field, {
                            onBlur: handleInputBlur,
                        })}
                        // className="block px-2.5 pb-2.5 pt-2 w-full text-base text-gray-900 bg-transparent rounded border border-gray-300 appearance-none dark:border-gray-600 dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-600 peer"
                        className="w-full outline-none"
                        placeholder=" "
                        defaultValue={defaultValue}
                        disabled={disabled}
                    />
                     {enableTranslation && (
                    <>
                        {isTranslating && (
                            <div className="text-sm text-gray-500 mt-1">
                                Translating...
                            </div>
                        )}

                        {!isTranslating && translation && (
                            <div className="text-sm text-gray-600 mt-1">
                                {translation}
                            </div>
                        )}
                    </>
                )} 
                </div>

                <label
                    htmlFor={field}
                    className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                    {label}
                </label>
            </div>

            {/* Display translation UI only when translation is enabled */}

            <ErrorTextWithIcon text={errors?.[field]?.message} />
        </div>
    );
};

export default FloatingLabelInputField;
